{
  "organizationLabel": "组织:",
  "profileDropdownAccountInfoItem": "帐户信息（内部）",
  "profileDropdownAccountSettingsHeader": "帐户设置",
  "profileDropdownProductSettingsHeader": "产品设置",
  "profileDropdownUserSettingsItem": "首选项",
  "profileLegalNoticesMenuItem": "法律声明",
  "signOut": "注销",
  "themeInfoTooltip": "并非所有应用程序都支持深色主题。",
  "userProfileName": "{lastName} {firstName}",
  "userThemeSwitchLabel": "深色主题"
}
